import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Tracks SPA route changes for Meta (Facebook) Pixel.
 * Deduplicates the initial load since index.html already fires the first PageView.
 */
function PixelRouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname, location.search]);

  return null;
}

export default PixelRouteTracker;
